import { datadogLogs } from '@datadog/browser-logs';

export function EmergePaySubmitted(settings) {
    if (window.chrome?.webview != null) {
      window.chrome.webview.postMessage({EVENT_TYPE: settings});
    } else {
      datadogLogs.logger.error("EmergePaySubmitted.WebviewUnavailable: window.chrome.webview not present — DMS will not receive EmergePay payment notification");
    }
  }